<template>
  <div id="dashboard">
    <HeaderDashboard />
    <div id="console-main">
      <div id="console-body">
        <router-view :key="$route.fullPath" />
      </div>
    </div>
  </div>
</template>

<script>
import HeaderDashboard from "@/components/HeaderDashboard.vue";

export default {
  name: "Dashboard",
  components: {
    HeaderDashboard
  }
};
</script>

<style>
#console-main {
  height: 100%;
  width: 100%;
  position: relative;
}
#console-body {
  padding: 20px 20px;
  background: #fafafa;
}
</style>
